import { ActionExtended } from "../../../_common/interfaces/ActionExtended";
import { ACTIONS } from "../../../_config";

export interface GlobalReducer {
  settings: any;
  seo_list: any;
  game_status_text: any;
}

const initialState: GlobalReducer = {
  settings: null,
  seo_list: null,
  game_status_text: null,
};

const globalsReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.COMMON.SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    case ACTIONS.COMMON.SEO_LIST:
      return {
        ...state,
        seo_list: action.payload.data,
      };
    case ACTIONS.COMMON.GET_GAME_STATUS_TEXT:
      return {
        ...state,
        game_status_text: action.payload,
      };
    default:
      return state;
  }
};

export default globalsReducer;
